import LotAvailability from './lot-availability';
export default LotAvailability;
